import http from "@/http/aisea/axios_v2";
const resource = "/enterprises/manning/vessels/alerts";
import qs from "qs";

/**
 * 船舶アラート一覧取得
 * 
 * @param {Object} params - 以下の条件で絞り込みが可能です。
 * details:
 *   - MANNING_VESSEL_ROLE
 *   - MANNING_VESSEL_ROLE_POSITION
 * kinds:
 *   - CREW_COMPATIBILITY
 *   - CREW_UNREGISTERED
 *   - DAY_OFF_REQUEST_DUPLICATED
 *   - DISEMBARKATION_STANDBY
 *   - EMBARKATION_STANDBY
 *   - LICENSE_EXPIRED
 */
export default {
  fetch(params) {
    return http.get(`${resource}`, {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },  
};
